import { createSlice } from '@reduxjs/toolkit'
// import createQueryString from 'src/utils/createQueryString'
import api from '../../api/index'
import { startLoading, stopLoading } from './loadingSlice'
import { failed, success } from './snackSlice'

export const packageSlice = createSlice({
  name: 'package',
  initialState: {
    usersPackages: [],
    discountPrice: null,
  },
  reducers: {
    packageFetched: (state, { payload }) => {
      state.packages = payload
    },
    paymentInfoFetched: (state, { payload }) => {
      state.payment = payload
    },
    allPackageFetched: (state, { payload }) => {
      state.allPackages = payload
    },
    onePackageFetched: (state, { payload }) => {
      state.onePackage = payload
    },
    usersPackageFetched: (state, { payload }) => {
      state.usersPackages = payload
    },
    discountPriceFetched: (state, { payload }) => {
      state.discountPrice = payload
    },
    examReportsFetch: (state, { payload }) => {
      state.examReports = payload
    },
    usersExtendPackageFetch: (state, { payload }) => {
      state.usersExtendPackage = payload
    },
  },
})

export default packageSlice.reducer

export const {
  packageFetched,
  paymentInfoFetched,
  allPackageFetched,
  onePackageFetched,
  usersPackageFetched,
  discountPriceFetched,
  examReportsFetch,
  usersExtendPackageFetch,
} = packageSlice.actions

export const getUserPackages = (callback) => (dispatch) => {
  const url = '/exam/user/package'
  dispatch(startLoading())

  api
    .get(url)
    .then((res) => {
      const pkg = res?.data?.data

      if (pkg?.length) dispatch(packageFetched(pkg))
      dispatch(stopLoading())
      if (callback && typeof (callback) === 'function') callback()
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const getUsersPackages = (params) => (dispatch) => {
  const url = 'exam/user'
  dispatch(startLoading())
  api
    .get(url, { params })
    .then((res) => {
      dispatch(usersPackageFetched(res?.data?.data))
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const payUserPackage = (params, navigate) => (dispatch) => {
  const url = '/exam/user/Pay'

  dispatch(startLoading())

  api
    .post(url, params)
    .then((res) => {
      dispatch(stopLoading())

      if (res?.data?.data?.httpMethod === 1) {
        const form = document.createElement('form')
        form.method = 'POST'
        form.action = res?.data?.data?.url
        res?.data?.data?.parameters?.forEach((param) => {
          const element = document.createElement('input')
          element.name = param?.key
          element.value = param?.value
          form.appendChild(element)
        })

        document.body.appendChild(form)
        form.submit()
      } else {
        const fullUrl = res?.data?.data?.url
        const redirectUrl = fullUrl.split(window.location.host)[1]
        navigate(redirectUrl)
      }
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const payExpiredUserPackage = (params, navigate) => (dispatch) => {
  const url = '/exam/user/RePay'

  dispatch(startLoading())

  api
    .post(url, params)
    .then((res) => {
      dispatch(stopLoading())

      if (res?.data?.data?.httpMethod === 1) {
        const form = document.createElement('form')
        form.method = 'POST'
        form.action = res?.data?.data?.url
        res?.data?.data?.parameters?.forEach((param) => {
          const element = document.createElement('input')
          element.name = param?.key
          element.value = param?.value
          form.appendChild(element)
        })

        document.body.appendChild(form)
        form.submit()
      } else {
        const fullUrl = res?.data?.data?.url
        const redirectUrl = fullUrl.split(window.location.host)[1]
        navigate(redirectUrl)
      }
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const checkDiscount = (code) => (dispatch) => {
  const url = `/exam/user/Check/Discount/${code}`

  dispatch(startLoading())

  api.get(url)
    .then((res) => {
      if (res?.data) {
        dispatch(discountPriceFetched(res?.data?.data))
      }
      dispatch(success('کد تخفیف با موفقیت اعمال شد'))
      dispatch(stopLoading())
    })
    .catch((err) => {
      dispatch(failed(err?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const getPayFactor = (payId) => (dispatch) => {
  const url = `/Payment/${payId}`

  dispatch(startLoading())

  api.get(url)
    .then((res) => {
      if (res?.data) {
        dispatch(discountPriceFetched(res?.data?.data))
      }
      dispatch(success('کد تخفیف با موفقیت اعمال شد'))
      dispatch(stopLoading())
      dispatch(success('بسته با موفقیت تمدید گردید'))
    })
    .catch((err) => {
      dispatch(failed(err?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const getPaymentInfo = (payId) => (dispatch) => {
  const url = `/Payment/${payId}`
  dispatch(startLoading())
  api
    .get(url)
    .then((res) => {
      // const info = res?.data?.data
      const info = res?.data
      if (info) dispatch(paymentInfoFetched(info))
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message, ''))
      dispatch(stopLoading())
    })
}

export const getAllPackages = (callback) => (dispatch) => {
  const url = '/exam/package'
  dispatch(startLoading())
  api
    .get(url)
    .then((res) => {
      const pkg = res?.data?.data
      if (pkg?.length) dispatch(allPackageFetched(pkg))
      dispatch(stopLoading())
      if (callback && typeof (callback) === 'function') callback()
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const extendPackageExpiryDate = (data, callback) => (dispatch) => {
  const url = 'package/User/Unlock'
  dispatch(startLoading())
  api
    .put(url, data)
    .then((res) => {
      dispatch(success('بسته با موفقیت تمدید گردید'))
      dispatch(stopLoading())
      if (callback) callback(res)
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const getUserExamReports = (UserExamId) => (dispatch) => {
  const url = `/exam/GradeReport/${UserExamId}`
  dispatch(startLoading())
  api
    .get(url)
    .then((res) => {
      const data = res?.data
      console.log('userExamReports', res)
      if (data) dispatch(examReportsFetch(data))
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const getAllUsersPackage = (filter) => (dispatch) => {
  const url = '/exam/user/package/search'
  dispatch(startLoading())
  api
    .post(url, filter)
    .then((res) => {
      const data = res?.data?.data
      if (data) dispatch(usersExtendPackageFetch(data))
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const unluckUserPackage = (model) => (dispatch) => {
  const url = '/exam/user/Unlock'
  dispatch(startLoading())
  api
    .put(url, model)
    .then((res) => {
      console.log(res)
      // const data = res?.data?.data
      // if (data) dispatch(usersExtendPackageFetch(data))
      dispatch(getAllUsersPackage({ Statuses: [106] }))
      dispatch(success('تمدید با موفقیت انجام شد'))
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const selectorUserPackage = (state) => state.package.packages
export const selectorPayment = (state) => state.package.payment
export const selectorAllPackage = (state) => state.package.allPackages
export const selectorUsersPackage = (state) => state.package.usersPackages
export const selectorDiscountPrice = (state) => state.package.discountPrice
export const selectorExamReports = (state) => state.package.examReports
export const selectorExtendUsersPackage = (state) => state.package.usersExtendPackage
